import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

export function initSlider() {
    const progressCircle = document.querySelector('[data-autoplay-wrapper] #icon-autoplay');

    const swiper = new Swiper('[data-features-slider]', {
        modules: [Autoplay],
        loop: true,
        centeredSlides: true,
        slidesPerView: 1,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        on: {
            autoplayTimeLeft(s, time, progress) {
                if (progressCircle) {
                    progressCircle.style.setProperty('--progress', progress);
                }
            },
        },
    });
}
